var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.348,
    height: 27.997,
    viewBox: "0 0 31.348 27.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handshake_1_",
    "data-name": "handshake (1)",
    transform: "translate(-2.007 -4.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M17.136,31.839l-.4-.4a1.113,1.113,0,0,0-1.58,0l-2.374,2.384a1.132,1.132,0,0,0,0,1.594l.4.4a1.113,1.113,0,0,0,1.58,0l2.374-2.384a1.131,1.131,0,0,0,0-1.593Z",
    transform: "translate(-4.599 -11.491)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M23.075,45.759a1.139,1.139,0,0,0,1.577,0v0l2.374-2.381,0,0a1.13,1.13,0,0,0,0-1.591l-.4-.4a1.141,1.141,0,0,0-1.58,0l-2.374,2.384a1.129,1.129,0,0,0,0,1.593Z",
    transform: "translate(-8.953 -15.872)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M28.027,50.718a1.113,1.113,0,0,0,1.578,0l2.372-2.383a1.129,1.129,0,0,0,0-1.592l-.392-.4a1.12,1.12,0,0,0-.792-.326,1.105,1.105,0,0,0-.784.325l-2.374,2.383a1.13,1.13,0,0,0,0,1.591Z",
    transform: "translate(-11.135 -18.05)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M18.917,41.113a1.108,1.108,0,0,0,.791-.329L22.082,38.4a1.132,1.132,0,0,0,0-1.594l-.4-.4a1.115,1.115,0,0,0-1.581,0l-2.374,2.384a1.132,1.132,0,0,0,0,1.594l.4.4a1.108,1.108,0,0,0,.79.329Z",
    transform: "translate(-6.775 -13.678)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M20.848,15.98l6.331,6.357a1.139,1.139,0,0,0,1.58,0l.4-.4a1.13,1.13,0,0,0,0-1.593l-8.7-8.741a.567.567,0,0,0-.788,0l-4.352,4.367a3.351,3.351,0,0,1-4.75,0,1.689,1.689,0,0,1,0-2.38l6.313-6.338a8.9,8.9,0,0,0-12.245.375,9.03,9.03,0,0,0,0,12.719l2.2,2.206a2.226,2.226,0,0,1,.57-1.014l2.374-2.384a2.234,2.234,0,0,1,3.168,0l.4.4a2.233,2.233,0,0,1,.637,1.76,2.24,2.24,0,0,1,1.736.623l.4.4a2.235,2.235,0,0,1,.638,1.74c.051,0,.1-.015.152-.015a2.223,2.223,0,0,1,1.584.658l.4.4a2.233,2.233,0,0,1,.637,1.761,2.25,2.25,0,0,1,1.736.621l.384.392s.008,0,.011.007a1.113,1.113,0,0,0,1.58,0l.4-.4a1.131,1.131,0,0,0,0-1.592l-6.328-6.358a.56.56,0,1,1,.794-.791l6.331,6.358a1.141,1.141,0,0,0,1.58,0l.4-.4a1.131,1.131,0,0,0,0-1.594l-6.33-6.357a.56.56,0,1,1,.794-.791Z",
    transform: "translate(0 0)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M37.735,20.572l.218-.219a9.03,9.03,0,0,0,0-12.718,8.922,8.922,0,0,0-12.655,0l-6.728,6.754a.567.567,0,0,0,0,.8,2.283,2.283,0,0,0,3.163,0l4.352-4.367a1.716,1.716,0,0,1,2.376,0l8.7,8.739a2.222,2.222,0,0,1,.571,1.012Z",
    transform: "translate(-7.217 -0.002)",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake1);
export default __webpack_public_path__ + "static/media/handshake_1.9cdf2d3b3e16da13fd82688d689d8f77.svg";
export { ForwardRef as ReactComponent };